import { render } from "./socialPage.vue?vue&type=template&id=0d65e1c4"
import script from "./socialPage.vue?vue&type=script&lang=js"
export * from "./socialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__